import React from 'react';
import { CTAButton } from './CTAButton';
export function IncludesSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const modules = ['creación del producto', 'estructura de oferta', 'configuración de Shopify', 'diseño base de tienda', 'vinculación de dominio', 'integración con Mercado Pago', 'Meta Ads', 'cuentas publicitarias', 'pixel y eventos', 'estructura base de campañas', 'uso de IA para acelerar implementación'];
  return <section className="bg-gray-50 py-16 md:py-24 px-4" data-id="element-138">
      <div className="max-w-6xl mx-auto" data-id="element-139">
        <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-12 text-center" data-id="element-140">
          ¿Qué incluye exactamente?
        </h2>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-141">
          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-green-500" data-id="element-142">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-143">
              Curso grabado
            </h3>
            <p className="text-lg text-gray-700" data-id="element-144">
              Un programa grabado paso a paso para que puedas avanzar a tu
              ritmo.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-blue-500" data-id="element-145">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-146">
              4 mentorías grupales en vivo
            </h3>
            <p className="text-lg text-gray-700" data-id="element-147">
              Una por semana para ayudarte a implementar, resolver dudas y
              corregir errores.
            </p>
          </div>
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-2xl p-8 md:p-12 mb-8" data-id="element-148">
          <h3 className="text-3xl font-bold mb-8 text-center" data-id="element-149">
            Módulos de formación práctica
          </h3>
          <p className="text-lg mb-6 text-center text-gray-300" data-id="element-150">
            Incluye contenido sobre:
          </p>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-151">
            {modules.map((module, index) => <div key={index} className="flex items-center gap-3 bg-gray-800 rounded-lg p-4" data-id="element-152">
                <span className="text-green-400 text-xl font-bold" data-id="element-153">✓</span>
                <span className="text-gray-200" data-id="element-154">{module}</span>
              </div>)}
          </div>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-lg" data-id="element-155">
          <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-156">
            Recursos extra
          </h3>
          <div className="grid md:grid-cols-4 gap-4 text-center" data-id="element-157">
            {['plantillas', 'prompts', 'guías prácticas', 'recursos de apoyo para implementar más rápido'].map((resource, index) => <div key={index} className="bg-green-50 rounded-lg p-4" data-id="element-158">
                <p className="text-lg font-semibold text-green-800" data-id="element-159">
                  {resource}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-160">
          <CTAButton text="QUIERO ACCEDER AL PROGRAMA" onClick={scrollToCompra} size="large" data-id="element-161" />
        </div>
      </div>
    </section>;
}